import { State } from "./State";
import { TokenList } from "./TokenList";
export class Room {
    constructor(eventsChannelFactory, id, accountId, enabled, integratedDisplay, showRoomQrInMonitor, pictureId, name, secondsBetweenMessages, state, gallery, roomRewards, offline, chroma, chroma_color) {
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.accountId = accountId;
        this.roomRewards = roomRewards;
        this.eventsChannel = undefined;
        this.enabled = new State(enabled);
        this.integratedDisplay = new State(integratedDisplay);
        this.showRoomQrInMonitor = new State(showRoomQrInMonitor);
        this.pictureId = new State(pictureId);
        this.name = new State(name);
        this.secondsBetweenMessages = new State(secondsBetweenMessages);
        this.state = new State(state);
        this.gallery = new TokenList(gallery);
        this.offline = new State(offline);
        this.chroma = new State(chroma);
        this.chroma_color = new State(chroma_color);
    }
    enableSync() {
        if (this.eventsChannel) {
            return;
        }
        this.eventsChannel = this.getEventsChannel();
        this.eventsChannel.on('state_change', ({ data }) => this.state.set(data.state));
    }
    disableSync() {
        if (!this.eventsChannel) {
            return;
        }
        this.eventsChannel.destroy();
        this.eventsChannel = undefined;
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`room.${this.id}`);
    }
    toJSON() {
        return {
            id: this.id,
            accountId: this.accountId,
            enabled: this.enabled.value,
            integratedDisplay: this.integratedDisplay.value,
            showRoomQrInMonitor: this.showRoomQrInMonitor.value,
            pictureId: this.pictureId.value,
            name: this.name.value,
            secondsBetweenMessages: this.secondsBetweenMessages.value,
            state: this.state.value,
            gallery: this.gallery,
            roomRewards: this.roomRewards,
            offline: this.offline,
            chroma: this.chroma,
            chroma_color: this.chroma_color,
        };
    }
}
